/**
 * Gateway 実装の配線（DI 入口）。
 *
 * usecase は domain のポート型に依存し、ここで実体を注入する。
 * ※ repositories とは別モジュールに分ける（テストでの差し替え単位を分離するため）。
 */
import type { CustomerQueryGateway } from "@/domain/repositoryInterface/CustomerQueryGateway";
import { SupabaseCustomerQueryGateway } from "./SupabaseCustomerQueryGateway";
import type { ShiftGateway } from "@/domain/repositoryInterface/ShiftGateway";
import { SupabaseShiftGateway } from "./SupabaseShiftGateway";
import type { BookingAvailabilityGateway } from "@/domain/repositoryInterface/BookingAvailabilityGateway";
import { SupabaseBookingAvailabilityGateway } from "./SupabaseBookingAvailabilityGateway";
import type { BookingGateway } from "@/domain/repositoryInterface/BookingGateway";
import { SupabaseBookingGateway } from "./SupabaseBookingGateway";
import type { SalesGateway } from "@/domain/repositoryInterface/SalesGateway";
import { SupabaseSalesGateway } from "./SupabaseSalesGateway";
import type { StaffGateway } from "@/domain/repositoryInterface/StaffGateway";
import { SupabaseStaffGateway } from "./SupabaseStaffGateway";
import type { GoogleCalendarGateway } from "@/domain/repositoryInterface/GoogleCalendarGateway";
import { SupabaseGoogleCalendarGateway } from "./SupabaseGoogleCalendarGateway";

export const customerQueryGateway: CustomerQueryGateway = new SupabaseCustomerQueryGateway();
export const shiftGateway: ShiftGateway = new SupabaseShiftGateway();
export const bookingAvailabilityGateway: BookingAvailabilityGateway =
  new SupabaseBookingAvailabilityGateway();
export const bookingGateway: BookingGateway = new SupabaseBookingGateway();
export const salesGateway: SalesGateway = new SupabaseSalesGateway();
export const staffGateway: StaffGateway = new SupabaseStaffGateway();
export const googleCalendarGateway: GoogleCalendarGateway =
  new SupabaseGoogleCalendarGateway();
